module.exports = __webpack_public_path__ + "img/front_bi.f4b85ca1.png";